import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip } from "chart.js";
import { useWebsite } from "../../../Context/WebSiteContext";

Chart.register(ArcElement, Tooltip);

const DoughnutStatus = ({ percentage, color, label }) => {
  const data = {
    labels: [label],
    datasets: [
      {
        data: [percentage, 100 - percentage],
        backgroundColor: [color, "#E0E0E0"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: "70%",
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    responsive: false,
    maintainAspectRatio: false,
  };

  return (
    <div style={{ position: "relative", width: 100, height: 100, margin: 12, display: "flex", flexDirection: "column", alignItems: "center", }}>
      <Doughnut data={data} options={options} width={100} height={100} />
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: 100,
        height: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        flexDirection: "column"
      }}>
        <span style={{ fontSize: 20, fontWeight: "bold", color }}>{percentage}%</span>
      </div>
      <div style={{ marginTop: 8, fontSize: 16, textAlign: "center" }}>{label}</div>
    </div>
  );
};

const StatusModern = ({ config }) => {
  const { formData } = useWebsite();

  const mergedConfig = useMemo(() => ({
    ...config,
    ...formData,
  }), [config, formData]);

  const primaryColor = mergedConfig.primaryColor ? `#${mergedConfig.primaryColor}` : "#ffffff";
  const statusList = mergedConfig.statusObra?.statusList || [];

  // Usa a cor customizada da barra de progresso, se existir
  const progressColor = mergedConfig.statusObra?.progressColor || "#000";
  const titleColor = mergedConfig.statusObra?.titleColor || "#000";

  return (
    <div style={{
      borderRadius: 16,
      padding: 24,
      width: "100%",
      margin: "0 auto"
    }} className="w-100 mb-3">
      <h2 style={{
        textAlign: "center",
        fontWeight: 800,
        fontSize: 38,
        marginBottom: 16,
        color: titleColor,
        letterSpacing: "-1px",
        textShadow: "0 2px 8px rgba(0,0,0,0.08)"
      }}>
         Status da obra
      </h2>
      {statusList.length > 0 ? (
        <div style={{
          display: "flex",
          justifyContent: "center",
          gap: 32,
          flexWrap: "wrap"
        }}>
          {statusList.map((s) => (
            <DoughnutStatus
              key={s.status}
              percentage={s.percentage}
              color={progressColor}
              label={s.status}
            />
          ))}
        </div>
      ) : (
        <p style={{ textAlign: "center", fontSize: 18, color: "#666" }}>
          Nenhum status disponível no momento.
        </p>
      )}
    </div>
  );
};

export default StatusModern;